import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import { resolveRubricElements } from '@linc-technologies/linced-common/utils/rubrics';

export default class GetRubricElements extends Helper {
  // Services
  @service
  dates;

  @service
  store;

  compute([subject, student, rubricFamilyId]) {
    return resolveRubricElements(
      subject,
      student,
      this.store,
      this.dates.rolloverMonthDate,
      rubricFamilyId,
    );
  }
}
